import SearchTypeSwitch from './SearchTypeSwitch'

export default SearchTypeSwitch
